'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002441 from "./presto.-Two-Factor-Auth-View$$anon$41.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024 from "./presto.types$-Two-Factor-Auth$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024 from "./presto.types$-Two-Factor-Auth-Name$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$40() {
  this.bDf = null;
  this.bD7 = null;
  this.bD8 = false;
  this.bDg = null;
  this.bDh = false;
  this.bDk = null;
  this.bDd = null;
  this.bDe = false;
  this.bD9 = null;
  this.bDa = false;
  this.bDb = null;
  this.bDc = false;
  this.bDi = false;
  this.bDj = false;
  this.bDf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bDk = "TwoFactorAuth";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$40 as $c_Lpresto_TwoFactorAuthView$$anon$40 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$40.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$40;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$40() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$40 as $h_Lpresto_TwoFactorAuthView$$anon$40 };
$h_Lpresto_TwoFactorAuthView$$anon$40.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bDf;
});
$p.L = (function() {
  if ((!this.bD8)) {
    this.bD7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bD8 = true;
  }
  return this.bD7;
});
$p.O = (function() {
  if ((!this.bDh)) {
    this.bDg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bDh = true;
  }
  return this.bDg;
});
$p.E = (function() {
  return this.bDk;
});
$p.t = (function() {
  if ((!this.bDe)) {
    this.bDd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bDe = true;
  }
  return this.bDd;
});
$p.M = (function() {
  if ((!this.bDa)) {
    this.bD9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().zd(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024.$m_Lpresto_types$TwoFactorAuthName$().ze(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024.$m_Lpresto_types$TwoFactorAuthType$().zg(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthPayload$().zf(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bDa = true;
  }
  return this.bD9;
});
$p.Q = (function() {
  if ((!this.bDc)) {
    this.bDb = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002441.$c_Lpresto_TwoFactorAuthView$$anon$41();
    this.bDc = true;
  }
  return this.bDb;
});
$p.w = (function() {
  if ((!this.bDj)) {
    this.bDi = false;
    this.bDj = true;
  }
  return this.bDi;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee353) => ((p) => \u03b4scrutinee353.z4(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024.$m_Lpresto_types$TwoFactorAuth$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$40 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$40, "presto.TwoFactorAuthView$$anon$40", ({
  SD: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$40 as $d_Lpresto_TwoFactorAuthView$$anon$40 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$40.js.map
